import { Link } from "react-router-dom";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const NotFoundPage = () => {
  return (
    <>
      <SiteTitle title="صفحه یافت نشد!" />
      <main className="h-screen w-full flex flex-col justify-center items-center bg-[#252839]">
        <h1 className="text-9xl font-extrabold text-white tracking-widest">
          404
        </h1>
        <div className="bg-[#FF6A3D] px-2 text-sm rounded rotate-12 absolute">
          صفحه یافت نشد
        </div>
        <Link
          to="/Public/Home"
          className="mt-5 inline-block px-6 py-2 text-white font-medium 
            text-sm tracking-wide border-2 border-green-600 rounded-xl 
            hover:bg-green-600 transition-all ease-linear duration-100"
        >
          صفحه اصلی
        </Link>
      </main>
    </>
  );
};

export default NotFoundPage;